import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash';
import Checkbox from "../../../../../components/checkbox";
import {Collapse} from "react-collapse";

function NumberOfPitcherAtBat(props) {
    const {selected} = props;
    const [isOpened, setIsOpened] = useState(false);
    const [listPitchesAtBat, listPitchesAtBatHelper] = useList([
        {
            value: 1,
            name: '1球目',
            checked: false,
        },
        {
            value: 2,
            name: '2球目',
            checked: false,
        },
        {
            value: 3,
            name: '3球目',
            checked: false,
        },
        {
            value: 4,
            name: '4球目以降',
            checked: false,
        },
    ]);
    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listPitchesAtBat.findIndex(i => i.value === item);
            listPitchesAtBat[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listPitchesAtBat,['checked', true]), 'value'));
    },[listPitchesAtBat]);

    const onChange = (item, index) => {
        listPitchesAtBatHelper.updateAt(index, {...item,checked: !item.checked});
    };

    return (
        <div className='inner-item-child group-filter-item'>
            <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                <h4>打席内投球数</h4>
                <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
            </div>
            <Collapse isOpened={isOpened}>
                <div className="filter-group">
                    {listPitchesAtBat.map((item,index) => {
                        return <div key={item.value} className={'search-main-advanced-checkbox'}>
                            <label>
                                <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                {item.name}
                            </label>
                        </div>
                    })}
                </div>
            </Collapse>
        </div>
    )
}

export default NumberOfPitcherAtBat;